export default "__VITE_ASSET__CxxNkeyA__"